"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    playSvgFill: {
        fill: function (data) { return data.color; },
    },
};
//# sourceMappingURL=play.theme.js.map